import React from 'react';
import './Contact.css';
import { CONTACT } from '../content';

export default function Contact() {
  return (
    <section id="contact" className="contact section-pad">
      <div className="wrap contact-inner">
        <p className="eyebrow eyebrow--accent">Contact</p>
        <h2 className="section-title contact-title">
          Looking for real-time work
        </h2>
        <p className="section-lede">
          Unity, engine, and graphics roles: interactive installations, simulation, XR. {CONTACT.location}.
        </p>

        <div className="contact-actions">
          <a href={`mailto:${CONTACT.email}`} className="btn btn--primary">
            {CONTACT.email}
          </a>
          <a href={CONTACT.phoneHref} className="btn">
            {CONTACT.phone}
          </a>
          <a href={CONTACT.resume} className="btn" download>
            Download résumé
            <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
              <path d="M8 1v10M4 7.5 8 11.5l4-4M2 14.5h12" />
            </svg>
          </a>
        </div>
      </div>

      <footer className="wrap site-footer">
        <p>© {new Date().getFullYear()} Jacob Noel</p>
        <a href="#top" className="footer-top">
          Back to top ↑
        </a>
      </footer>
    </section>
  );
}
